<template>
  <div>
    <form @submit.prevent="signIn">
      <input id="input_email" type="email" v-model=user placeholder="user" />
      <input id="input_password" type="password" v-model=password placeholder="password" />
      <button id="btn_signin" class="btn btn-default">ログイン</button>
    </form>

  <div id="database" class="database">
    <h3>参加者登録内容</h3>
    <hr>

    <table><tbody>
      <tr>
        <th>氏名</th>
        <th>所属</th>
        <th>身分</th>
        <th>メールアドレス</th>
        <!-- <th>講演希望</th> -->
        <!-- <th>講演タイトル</th> -->
        <th>懇親会参加希望</th>
        <th>参加日程</th>
        <th>コメント</th>
        <th>登録日時</th>
      </tr>
      <tr v-for="(participant, idx) in db_participants" :key="idx">
          <td>{{ participant.name }}</td>
          <td>{{ participant.belong }}</td>
          <td>{{ participant.position }}</td>
          <td>{{ participant.email }}</td>
          <!-- <td>{{ participant.talk.do }}</td> -->
          <!-- <td>{{ participant.talk.title }}</td> -->
          <td>{{ participant.banquet }}</td>
          <td>{{ participant.participation }}</td>
          <td>{{ participant.message }}</td>
          <td>{{ participant.datetime.toDate().toLocaleString() }}</td>
      </tr>
    </tbody></table>

  </div>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import { db } from '../main'

export default {
  name: 'DataBase',
  data () {
    return {
      user: '',
      password: '',
      db_participants: null
    }
  },
  firestore () {
    return {
      db_participants: db.collection('participants').orderBy('datetime')
    }
  },
  methods: {
    signIn: function () {
      var btn = document.getElementById('btn_signin')
      btn.disabled = true
      firebase.auth().signInWithEmailAndPassword(this.user, this.password).then(function () {
        document.getElementById('input_email').disabled = true
        document.getElementById('input_password').disabled = true
        document.getElementById('database').style.display = 'block'
      }).catch(function (error) {
        alert(error.message)
        btn.disabled = false
      })
    }
  }
}
</script>

<style>

.database {
  display: none;
}
.database table {
  border-collapse: collapse;
  border: solid 3px rgb(34,110,147);
  table-layout: fixed;
  width: 100%;
}
.database table th, table td {
  border: dashed 1px rgb(101, 101, 101);
  padding: 10px;
  text-align: center;
}
.database table th {
  background-color:rgb(34,110,147);
  color: white;
}

</style>



// WEBPACK FOOTER //
// src/components/DataBase.vue